<template>
	<div id="app" class="GlobalContainer">
		<div class='PageContainer'>
			<!-- <app-modal/> -->
      <transition name="fade" mode="out-in" class='PageContainer'>
			<router-view />
      </transition>
	</div>
  </div>
</template>

<script>

const whatIntroVideoPlayed = false;

export default {
	data () {
		return {
			whatIntroVideoPlayed,
		}
	}
}
</script>

<style lang="scss">
	@import '../node_modules/bootstrap/scss/bootstrap.scss';
	@import './assets/scss/_site.scss';

  .fade-enter-active, .fade-leave-active {
    transition: opacity 250ms;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0.1;
  }
</style>